import React from 'react'
import { Button, Icon } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../hooks';
import { GoX } from "react-icons/go";

export function Logout() {

    const { logout } = useAuth();
    const navigate = useNavigate();

    const onLogout = () => {
        logout();
        navigate("/");
    };

  return (
    <Button icon basic color='red' onClick={onLogout}>
        <GoX size="20" /> Log Out
    </Button>
  )
}
